(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_pdp_variant-size-guide"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    function initializeSizeGuide() {
        const sizeButton = document.querySelector('.size');
        const sizeDrawer = document.querySelector('.size-drawer');
        const sizeDrawerInner = document.querySelector('.size-drawer .drawer__inner');
        const closesizeDrawer = document.querySelector('.close-size-drawer');
        const infoWrapper = document.querySelector('.info-wrapper');

        sizeButton?.addEventListener('click', function(e) {
            e.preventDefault();
            sizeDrawer.classList.add('active');
            infoWrapper.classList.add('z-index-high');
            document.body.classList.add('overflow-hidden');
        });

        closesizeDrawer?.addEventListener('click', function() {
            sizeDrawer.classList.remove('active');
            infoWrapper.classList.remove('z-index-high');
            document.body.classList.remove('overflow-hidden');
        });

        document.addEventListener('click', function(e) {
            if (
                sizeDrawer.classList.contains('active') &&
                e.target !== sizeButton &&
                !sizeButton.contains(e.target) &&
                !sizeDrawerInner.contains(e.target)
            ) {
                sizeDrawer.classList.remove('active');
                infoWrapper.classList.remove('z-index-high');
                document.body.classList.remove('overflow-hidden');
            }
        });
    }

    function initializeSizeGuideUnits() {
        const cmButton = document.querySelector('.size-guide-mesure-unit-cm');
        const inButton = document.querySelector('.size-guide-mesure-unit-in');
        const cmTable = document.querySelector('.size-guide-table-cm');
        const inTable = document.querySelector('.size-guide-table-in');

        function setActiveUnit(activeButton, inactiveButton) {
            activeButton.classList.add('active');
            inactiveButton.classList.remove('active');
        }

        cmButton?.addEventListener('click', function () {
            cmTable?.classList.remove('hidden');
            inTable?.classList.add('hidden');
            setActiveUnit(cmButton, inButton);
        });

        inButton?.addEventListener('click', function () {
            inTable?.classList.remove('hidden');
            cmTable?.classList.add('hidden');
            setActiveUnit(inButton, cmButton);
        });
    }

    function initializeSizeGuideTables() {
        const tables = document.querySelectorAll('.size-guide-table');

        tables.forEach((table) => {
            table.addEventListener('mouseover', function (e) {
                const cell = e.target.closest('td, th');
                if (!cell) return;

                const row = cell.parentElement;
                const columnIndex = Array.from(row.children).indexOf(cell);

                row.classList.add('highlight-row');

                Array.from(table.rows).forEach((row) => {
                    row.children[columnIndex]?.classList.add('highlight-column');
                });
            });

            table.addEventListener('mouseout', function (e) {
                const cell = e.target.closest('td, th');
                if (!cell) return;

                const row = cell.parentElement;
                const columnIndex = Array.from(row.children).indexOf(cell);

                row.classList.remove('highlight-row');

                Array.from(table.rows).forEach((row) => {
                    row.children[columnIndex]?.classList.remove('highlight-column');
                });
            });
        });
    }

    initializeSizeGuide();
    initializeSizeGuideUnits();
    initializeSizeGuideTables();
});
  } catch(e) { console.error(e); }
})();

})();
